// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"346a3521","442":"9c1f285c","446":"6b59ae24"}[chunkId] + ".chunk.css";
};